/* eslint-disable */
// @ts-nocheck

import { useContext } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { FaArrowRotateRight } from 'react-icons/fa6'

import useServer from '../../../api/useServerMain'
import InputDuration from '../../../components/forms/InputDuration'
import TextArea from '../../../components/forms/TextArea'
import Button from '../../../components/misc/Button'
import {
  durationTimeToMinutes,
  minutesToDurationTime,
} from '../../../utils/helpers'
import { DetailProductContext } from '../DetailProductContainer'

const ProcessedGeneral = () => {
  const { denyRoles } = useServer()

  const { product, updateProduct } = useContext(DetailProductContext)

  const { handleSubmit, control } = useForm()

  const onSubmit: SubmitHandler<Record<string, any>> = (data) => {
    const { elaborationSteps, averagePreparationTime } = data

    const dataToSend = {
      elaborationSteps,
      averagePreparationTime: durationTimeToMinutes(averagePreparationTime),
    }
    updateProduct!(product?.id, dataToSend)
  }

  return (
    <form
      className="grid grid-cols-1 place-content-between"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="flex h-auto flex-col items-start justify-start gap-2 rounded-md border border-slate-300 p-7">
        <InputDuration
          control={control}
          defaultValue={minutesToDurationTime(
            product?.averagePreparationTime ?? 0
          )}
          label={'Tiempo de preparación (HH:MM)'}
          name={'averagePreparationTime'}
        />
        <div className="w-full">
          <TextArea
            control={control}
            defaultValue={product?.elaborationSteps}
            label="Pasos de elaboración"
            name="elaborationSteps"
            textareaClassName={'h-[40dvh]'}
          />
        </div>
      </div>

      <div className="flex justify-end py-4">
        {denyRoles(['AUDITOR']) && (
          <Button
            color="slate-600"
            icon={<FaArrowRotateRight className={`h-5`} />}
            name="Actualizar"
            type="submit"
          />
        )}
      </div>
    </form>
  )
}

export default ProcessedGeneral
